export var DocumentAttachmentStatus;
(function (DocumentAttachmentStatus) {
    DocumentAttachmentStatus[DocumentAttachmentStatus["Recorded"] = 0] = "Recorded";
    DocumentAttachmentStatus[DocumentAttachmentStatus["Generating"] = 1] = "Generating";
    DocumentAttachmentStatus[DocumentAttachmentStatus["Saved"] = 2] = "Saved";
    DocumentAttachmentStatus[DocumentAttachmentStatus["Failed"] = 3] = "Failed";
})(DocumentAttachmentStatus || (DocumentAttachmentStatus = {}));
